import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { fetchRequest as getMyCourseAction, selectCourse as selectMyCourseAction, notified as notifiedAction } from '../../store/myCourse/actions'
import { getMyCourse } from '../../store/myCourse/selectors';
import MyCourseList from '../Course/myCourseList';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Button, Col, Row, Spinner,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    Card, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, Badge
} from 'reactstrap';
import { IUser } from '../../store/interface'
// @ts-ignore
import { store } from 'react-notifications-component';
import queryString from 'query-string'
// Separate state props + dispatch props to their own interfaces.

interface PropsFromState {
    user:IUser
    route: any
    data: any
    ui : any
    // loading: boolean
    // totalDoc: number
}

interface IState {
    firstLoad : boolean
    sorting : string
    offset: number
    limit: number
    year:number
    dropdownYearOpen: boolean
    cpdPointList : [],
    modalPaymentResultPopupState : boolean
    modelPaymentOrderNumber : string,
    modelPaymentAmt : string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    fetchRequest: typeof getMyCourseAction
    notified: typeof notifiedAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class CoursePage extends React.Component<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
            firstLoad : true,
            sorting: '',
            offset : 0,
            limit: 50,
            year: new Date().getFullYear(), // Default selection to current year
            dropdownYearOpen : false,
            cpdPointList: [],
            modalPaymentResultPopupState : false,
            modelPaymentOrderNumber : '',
            modelPaymentAmt : ''

        };
        this.onChangeYear = this.onChangeYear.bind(this);
        this.handleModalPaymentResultMessage = this.handleModalPaymentResultMessage.bind(this);
    }

    public componentDidMount() {
        const parsed = queryString.parse(this.props.route.location.search);
        if (parsed.pmtStatus && parsed.orderNo && parsed.amount){
            if (parsed.pmtStatus === "success"){
                this.setState({
                    modalPaymentResultPopupState : !this.state.modalPaymentResultPopupState,
                    modelPaymentOrderNumber : parsed.orderNo.toString(),
                    modelPaymentAmt : parsed.amount.toString()
                });
            }
        }

        const { fetchRequest: fr, data } = this.props
        // if (data.length === 0)
        //     fr();

        var searchParams:any = {};         
        searchParams["limit"] = this.state.limit;
        searchParams["year"] = this.state.year;
        // if (data.length == 0){ // Get only if haven't loaded 
        //     fr(searchParams);
        // }
        if (this.state.firstLoad){
            this.setState({firstLoad : false}, () => {
                //fr(searchParams);
                fr(searchParams);
            });
        }
        
        if (this.props.user.userStatus === "")
        {
            store.addNotification({
                title: "Reminder",
                message: "Please update your user profile before proceed",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 3000,
                  onScreen: true
                }
              });
        } else if (this.props.user.userStatus === "Pending Approval"){
            if (!this.props.ui.notificed){
                store.addNotification({
                    title: "Reminder",
                    message: "Your User profile is pending admin approval. You still can continue watch video while pending approval.",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                    duration: 3000,
                    onScreen: true
                    }
                });
                this.props.notified();
            }
        }
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.data != this.props.data){
            var result:any = [];
            this.props.data.map(function (d:any) {
                if (d.certIsGenerated){
                    d.cpdPoints.forEach((c: any) => {
                        if (c.profession in result){
                            result[c.profession] += c.points;
                        }else{
                            result[c.profession] = c.points;
                        }
                    });
                }
            });
            this.setState({cpdPointList: result });
        }
    }
    private LoadMore(d:any) { 
        this.setState({offset : this.state.offset +  this.state.limit}, () => {
            var searchParams:any = {};
            searchParams["sorting"] = this.state.sorting;
            searchParams["offset"] = this.state.offset;
            searchParams["limit"] = this.state.limit;          
            searchParams["year"] = this.state.year;
            this.props.fetchRequest(searchParams);
        }); 
    }

    private Sorting(d:any) { 
        //console.log("searchSorting:" + d.searchSorting);

        this.setState({offset : 0, sorting : d.searchSorting}, () => {
            var searchParams:any = {};
            searchParams["sorting"] = this.state.sorting;
            searchParams["offset"] = this.state.offset;
            searchParams["limit"] = this.state.limit;          
            searchParams["year"] = this.state.year;
            this.props.fetchRequest(searchParams);
        }); 
    }

    
    onChangeYear(e:any){
        var selectedYear = e.currentTarget.textContent;
        if (selectedYear === "All") selectedYear = 0;
        this.setState({ year: selectedYear}, () => {
            var searchParams:any = {};
            searchParams["sorting"] = this.state.sorting;
            searchParams["offset"] = this.state.offset;
            searchParams["limit"] = this.state.limit;            
            searchParams["year"] = this.state.year;
            this.props.fetchRequest(searchParams);
        });
    }

    handleModalPaymentResultMessage(){
        this.setState({modalPaymentResultPopupState : !this.state.modalPaymentResultPopupState});
    }
    public render() {
        const { loading } = this.props.ui
        const toggleDropDrownYear = () => this.setState({dropdownYearOpen : !this.state.dropdownYearOpen}); 

        return (
            <div>
                <br />
                <Row>
                    <Col lg="2"><span style={{float:"left"}}>Year&nbsp;:&nbsp;</span>
                        <Dropdown isOpen={this.state.dropdownYearOpen} size="sm" toggle={toggleDropDrownYear} block>
                            <DropdownToggle caret>{this.state.year == 0 ? "All": this.state.year}</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem header>Choose Year</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={this.onChangeYear}>All</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2020</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2021</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2022</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2023</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2024</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2025</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                    {
//                    this.state.cpdPointList.length > 0 && (
                    // <Col lg="10">
                    //     <React.Fragment>
                    //         <span style={{float:"left"}}>Accumulate Hours/Points&nbsp;:&nbsp;</span>
                    //         {
                    //             Object.entries(this.state.cpdPointList).map(([key,value])=>{
                    //                 return <span><Badge color="info" style={{fontSize:"large"}}>
                    //                             {key}&nbsp;
                    //                             <Badge color="light">&nbsp;{value}&nbsp;</Badge>
                    //                         </Badge>&nbsp;</span>;
                    //             })
                    //         }
                    //     </React.Fragment>
                    // </Col> 
                    //)
                    }
                </Row>
                {
                    loading ? (
                        <span>
                            <Spinner color="warning"/>
                            Loading...
                        </span>
                    ) : (
                        <React.Fragment>
                            {/* {JSON.stringify(this.props.data)} */}

                            <MyCourseList 
                                onLoadMore={this.LoadMore.bind(this)} 
                                onSorting={this.Sorting.bind(this)} 
                                data={this.props.data} 
                                user = {this.props.user} 
                                loading={this.props.ui.loading} 
                                firstLoad = {this.state.firstLoad}
                                totalDocument={this.props.ui.totalDoc} 
                                offset={this.state.offset} limit={this.state.limit}  />
                        </React.Fragment>
                    )
                }
               <Modal size="md" isOpen={this.state.modalPaymentResultPopupState} unmountOnClose={true}>
                    <ModalHeader toggle={this.handleModalPaymentResultMessage}><i className="fas fa-check mr-1"></i>Payment Completed</ModalHeader>
                    <ModalBody>
                        {/* <Label>Your Order Number&nbsp;:&nbsp;{this.state.modelPaymentOrderNumber}</Label><br/> */}
                        <Label>Amount Paid&nbsp;:&nbsp;{this.state.modelPaymentAmt}</Label><br/>
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="primary" onClick={this.handleSendAskTrainer}>Send</Button>{' '} */}
                        <Button color="secondary" onClick={this.handleModalPaymentResultMessage}>Okay</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    //user: state.userReducer
    user: state.userInfo.byId[0],
    ui : state.mycourse.ui,
    data: getMyCourse(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getMyCourseAction,
    notified: notifiedAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CoursePage)
